__turbopack_context__.v({
  "body": "portal-module-scss-module__RHRlFa__body",
  "portal": "portal-module-scss-module__RHRlFa__portal",
});
